/**
 * Languages Map
 *
 * Static reference data mapping ISO 639-3 language codes to language names.
 * Derived from backend/models/enums/languages.json.
 */

import type { LanguagesMap } from '@/types';

export const LANGUAGES: LanguagesMap = {
  AFR: 'Afrikaans',
  SQI: 'Albanian',
  AMH: 'Amharic',
  ARA: 'Arabic',
  OCI: 'Aranese',
  HYE: 'Armenian',
  ASM: 'Assamese',
  AYM: 'Aymara',
  AZE: 'Azerbaijani',
  BNT: 'Bantu',
  EUS: 'Basque',
  BEL: 'Belarusian',
  BEN: 'Bengali',
  BER: 'Berber',
  BRX: 'Bodo',
  BOS: 'Bosnian',
  BUL: 'Bulgarian',
  MYA: 'Burmese',
  YUE: 'Cantonese (Chinese)',
  KEA: 'Cape Verdean Creole',
  CAL: 'Carolinian',
  CAT: 'Catalan',
  CHA: 'Chamorro',
  NYA: 'Chewa',
  ZHO: 'Chinese',
  CRP: 'Creole',
  HRV: 'Croatian',
  CES: 'Czech',
  DAN: 'Danish',
  DOI: 'Dogri',
  NLD: 'Dutch, Flemish',
  DZO: 'Dzongkha, Bhutanese',
  ENG: 'English',
  EPO: 'Esperanto',
  EST: 'Estonian',
  FAO: 'Faroese',
  FIJ: 'Fijian',
  FIL: 'Filipino',
  FIN: 'Finnish',
  FRA: 'French',
  GAG: 'Gagauz',
  GLG: 'Galician',
  KAT: 'Georgian',
  DEU: 'German',
  GRE: 'Greek',
  KAL: 'Greenlandic',
  GRN: 'Guarani',
  GUJ: 'Gujarati',
  HAT: 'Haitian Creole',
  HAU: 'Hausa',
  HAW: 'Hawaiian',
  HEB: 'Hebrew',
  HIN: 'Hindi',
  HUN: 'Hungarian',
  ISL: 'Icelandic',
  IKU: 'Inuktitut',
  GLE: 'Irish',
  ITA: 'Italian',
  JPN: 'Japanese',
  KAN: 'Kannada',
  KAS: 'Kashmiri',
  KAZ: 'Kazakh',
  KHM: 'Khmer',
  KIN: 'Kinyarwanda',
  RUN: 'Kirundi',
  KOK: 'Konkani',
  KOR: 'Korean',
  KUR: 'Kurdish',
  KIR: 'Kyrghyz',
  LAO: 'Lao',
  LAV: 'Latvian',
  LIN: 'Lingala',
  LIT: 'Lithuanian',
  LTZ: 'Luxembourgish',
  MKD: 'Macedonian',
  MAI: 'Maithili',
  MIG: 'Malagasy',
  MLY: 'Malay',
  MAL: 'Malayalam',
  DIV: 'Maldivian',
  MLT: 'Maltese',
  CMN: 'Mandarin (Chinese)',
  MNI: 'Manipuri',
  GLV: 'Manx Gaelic',
  MRI: 'Maori',
  MAR: 'Marathi',
  MAH: 'Marshallese',
  RUM: 'Moldovan',
  MON: 'Mongolian',
  CNR: 'Montenegrin',
  NAU: 'Nauruan',
  NEP: 'Nepali',
  NIU: 'Niue',
  NOR: 'Norwegian',
  ORI: 'Oriya',
  PAU: 'Palauan',
  PAP: 'Papiamento',
  PUS: 'Pashto',
  FAS: 'Persian, Farsi',
  POL: 'Polish',
  POR: 'Portuguese',
  PAN: 'Punjabi',
  QUE: 'Quechua',
  RON: 'Romanian',
  ROH: 'Romansh',
  RUS: 'Russian',
  RUE: 'Rusyn',
  SME: 'Sami',
  SMO: 'Samoan',
  SAG: 'Sango',
  SAN: 'Sanskrit',
  SAT: 'Santali',
  GLA: 'Scottish Gaelic',
  SRP: 'Serbian',
  CRS: 'Seychellois Creole',
  SND: 'Sindhi',
  SIN: 'Sinhalese',
  SLK: 'Slovak',
  SLV: 'Slovenian',
  SOM: 'Somali',
  SOT: 'Sotho',
  SPA: 'Spanish',
  SWA: 'Swahili',
  SSW: 'Swati',
  SWE: 'Swedish',
  TGL: 'Tagalog',
  TGK: 'Tajik',
  TAM: 'Tamil',
  TEL: 'Telugu',
  TET: 'Tetum',
  THA: 'Thai',
  TIR: 'Tigrinya',
  TKL: 'Tokelauan',
  TON: 'Tongan',
  TSN: 'Tswana',
  TUR: 'Turkish',
  TUK: 'Turkmen',
  TVL: 'Tuvaluan',
  UKR: 'Ukrainian',
  URD: 'Urdu',
  UZB: 'Uzbek',
  VEN: 'Venda',
  VIE: 'Vietnamese',
  CYM: 'Welsh',
  XHO: 'Xhosa',
  ZUL: 'Zulu',
  'sgn-IT': 'Italian Sign',
  'sgn-Fr': 'French Sign',
  IS: 'International Sign',
  LSE: 'Spanish Sign Language',
  BSL: 'British Sign Language',
  ASL: 'American Sign Language',
  DGS: 'German Sign Language',
} as const;
